import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LogoDesmontando from './LogoDesmontando';

function NotFound() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isAuthenticated } = useAuth();

    return (
        <div className="min-h-screen bg-slate-100 dark:bg-slate-900 flex items-center justify-center px-4 py-10 text-slate-900 dark:text-white">
            <main className="w-full max-w-4xl rounded-3xl border border-slate-200 dark:border-slate-700/60 bg-white dark:bg-slate-800/50 p-6 sm:p-12">
                <LogoDesmontando />

                <div className="mt-8 max-w-xl">
                    <p className="text-xs font-bold uppercase tracking-[0.12em] text-slate-500 dark:text-slate-400">Erro 404</p>
                    <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight">Eita, essa página desmontou.</h1>
                    <p className="mt-3 text-slate-600 dark:text-slate-400">
                        O endereço{' '}
                        <code className="break-all rounded-md bg-slate-100 dark:bg-slate-700/60 px-1.5 py-0.5 text-[0.9em] text-slate-800 dark:text-slate-200">{pathname}</code>
                        {' '}não existe ou mudou de lugar.
                    </p>

                    <div className="mt-6 flex flex-wrap gap-3">
                        <button
                            onClick={() => navigate(-1)}
                            className="bg-slate-200 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-600 px-6 py-2 rounded-lg font-medium transition-colors"
                        >
                            Voltar
                        </button>
                        <button
                            onClick={() => navigate(isAuthenticated() ? '/dashboard' : '/login')}
                            className="bg-[#0974BA] hover:bg-[#0974BA]/80 text-white px-6 py-2 rounded-lg font-medium transition-colors"
                        >
                            {isAuthenticated() ? 'Ir para o Dashboard' : 'Ir para o Login'}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default NotFound;
